// Vistorias analisadas (aba hist), ações em lote, reprovação com motivo, PDF, anexo, galeria e
// notificação. Port de index.html:4591–5006. Lista vem de GET /api/vistorias.

import type { VistoriaCompletaDTO, VistoriaDTO } from '../compartilhado/api.js';
import { api, ErroApi } from './api.js';
import { G, can, carregarVistorias, carregando, makeCard, renderAdmin, semAprovar } from './gestao-shell.js';
import { doApprove } from './gestao-dash.js';
import { buildPDF, relatorioDaApi } from './pdf.js';
import { S } from './vistoriador.js';
import { COR_FORM, baixarUrl, esc, toast } from './util.js';

function vistoria(id: string): VistoriaDTO | undefined { return G.vistorias.find(function (x: VistoriaDTO) { return x.id === id; }); }
function silencioso401(e: any) { return e instanceof ErroApi && e.status === 401; }

function histFiltradas(subs: VistoriaDTO[]) {
  const n = (G.histF.nome || '').toLowerCase();
  return subs.filter(function (s) {
    const st = s.status;
    const ms = !G.histF.st || st === G.histF.st;
    const mn = !n || (s.alojNome || '').toLowerCase().indexOf(n) >= 0 || (s.responsavel || '').toLowerCase().indexOf(n) >= 0 || (s.obraNome || '').toLowerCase().indexOf(n) >= 0;
    const mc = !G.histF.comp || s.competencia === G.histF.comp;
    return ms && mn && mc;
  });
}

export async function buildHist(el: HTMLElement) {
  carregando(el);
  const subs: VistoriaDTO[] = await carregarVistorias();
  if (S.tab !== 'hist') return;
  el.innerHTML = '';
  const card = makeCard('📋 Historico de vistorias', function (b) {
    const cont: any = { todas: subs.length, pendente: 0, aprovada: 0, reprovada: 0 };
    subs.forEach(function (s) { cont[s.status]++; });

    const chips = document.createElement('div');
    chips.style.cssText = 'display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px';
    [['', 'Todas', cont.todas, '#1F3864'], ['pendente', '⏳ Pendentes', cont.pendente, '#d97706'],
      ['aprovada', '✅ Aprovadas', cont.aprovada, '#16a34a'], ['reprovada', '✕ Reprovadas', cont.reprovada, '#dc2626']]
      .forEach(function (f) {
        const c = document.createElement('button');
        const on = (G.histF.st === f[0]);
        c.style.cssText = 'border-radius:99px;padding:6px 14px;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit;border:1.5px solid ' + f[3] + ';' +
          (on ? ('background:' + f[3] + ';color:#fff') : ('background:#fff;color:' + f[3]));
        c.textContent = f[1] + ' (' + f[2] + ')';
        c.onclick = function () { G.histF.st = f[0]; renderAdmin('hist'); };
        chips.appendChild(c);
      });
    b.appendChild(chips);

    const linha = document.createElement('div');
    linha.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:14px';
    const nomeInp = document.createElement('input');
    nomeInp.type = 'text'; nomeInp.placeholder = '🔍 Alojamento / responsável / obra';
    nomeInp.value = G.histF.nome;
    nomeInp.style.cssText = 'padding:8px 12px;border:1.5px solid #e2e8f0;border-radius:10px;font-size:12px;outline:none';
    const compSel = document.createElement('select');
    compSel.style.cssText = 'padding:8px 12px;border:1.5px solid #e2e8f0;border-radius:10px;font-size:12px;color:#1e293b;outline:none';
    const meses: Record<string, string> = {};
    subs.forEach(function (s) { meses[s.competencia] = s.competenciaRotulo; });
    const o0 = document.createElement('option'); o0.value = ''; o0.textContent = 'Todas as competências'; compSel.appendChild(o0);
    // ordem cronológica, mais recente primeiro (decisão 7.12)
    Object.keys(meses).sort().reverse().forEach(function (m) {
      const o = document.createElement('option'); o.value = m; o.textContent = meses[m] as string;
      if (G.histF.comp === m) o.selected = true; compSel.appendChild(o);
    });
    linha.appendChild(nomeInp); linha.appendChild(compSel); b.appendChild(linha);

    const listEl = document.createElement('div'); listEl.id = 'hist-list'; b.appendChild(listEl);
    function refresh() {
      G.histF.nome = nomeInp.value; G.histF.comp = compSel.value;
      const f = histFiltradas(subs);
      listEl.innerHTML = buildHistHTML(f.slice(0, 200));
      if (f.length > 200) {
        const av = document.createElement('div');
        av.style.cssText = 'text-align:center;font-size:12px;color:#94a3b8;padding:8px';
        av.textContent = 'Mostrando as 200 mais recentes de ' + f.length + '. Use os filtros para achar as demais.';
        listEl.appendChild(av);
      }
      updateHistSel();
    }
    let _t: any = null;
    nomeInp.oninput = function () { clearTimeout(_t); _t = setTimeout(refresh, 250); };
    compSel.onchange = refresh;
    refresh();
  });
  el.appendChild(card);
}

// ── Ações em lote ──────────────────────────────────────────────────────────
function histSelecionadas(): string[] {
  return Array.prototype.slice.call(document.querySelectorAll('.hist-cb:checked')).map(function (c: any) { return c.getAttribute('data-id'); });
}
async function bulkUpdate(ids: string[], corpo: any, btn: any, rotulo: string) {
  if (semAprovar()) return null;
  let okN = 0, errN = 0;
  for (let i = 0; i < ids.length; i++) {
    if (btn) btn.textContent = rotulo + ' ' + (i + 1) + '/' + ids.length + '...';
    try { await api('PATCH', '/api/vistorias/' + encodeURIComponent(ids[i] as string) + '/analise', corpo); okN++; }
    catch (e: any) { if (silencioso401(e)) return null; errN++; }
  }
  return { ok: okN, err: errN };
}
export function approveSelectedHist(btn: any) {
  if (semAprovar()) return;
  const ids = histSelecionadas();
  if (!ids.length) return;
  if (!confirm('Aprovar ' + ids.length + ' vistoria(s)?')) return;
  if (btn) btn.disabled = true;
  bulkUpdate(ids, { status: 'aprovada' }, btn, 'Aprovando').then(function (r) {
    if (!r) return;
    if (r.err) toast('⚠️ ' + r.ok + ' aprovada(s), ' + r.err + ' sem sincronizar', 'error');
    else toast('✅ ' + r.ok + ' vistoria(s) aprovada(s)', 'success');
    renderAdmin('hist');
  });
}
export function rejectSelectedHist(btn: any) {
  if (semAprovar()) return;
  const ids = histSelecionadas();
  if (!ids.length) return;
  let motivo = prompt('Motivo da reprovação (vale para as ' + ids.length + ' selecionadas):', '');
  if (motivo === null) return;
  motivo = motivo.trim();
  if (!motivo) { alert('O motivo é obrigatório.'); return; }
  if (btn) btn.disabled = true;
  bulkUpdate(ids, { status: 'reprovada', motivo }, btn, 'Reprovando').then(function (r) {
    if (!r) return;
    if (r.err) toast('⚠️ ' + r.ok + ' reprovada(s), ' + r.err + ' sem sincronizar', 'error');
    else toast('✕ ' + r.ok + ' vistoria(s) reprovada(s)', 'error');
    renderAdmin('hist');
  });
}
export async function deleteSelectedHist(btn: any) {
  if (semAprovar()) return;
  const ids = histSelecionadas();
  if (!ids.length) return;
  if (!confirm('Excluir definitivamente ' + ids.length + ' vistoria(s)? Não tem como desfazer.')) return;
  if (btn) btn.disabled = true;
  try {
    await api('POST', '/api/vistorias/excluir-lote', { ids });
    toast('🗑️ ' + ids.length + ' vistoria(s) excluída(s)', 'error');
  } catch (e: any) { if (silencioso401(e)) return; toast('⚠️ Não foi possível excluir: ' + e.message, 'error'); }
  renderAdmin(S.tab === 'hist' ? 'hist' : S.tab);
}

function buildHistHTML(arr: VistoriaDTO[]) {
  if (!arr || !arr.length) return '<div style="text-align:center;padding:20px;color:#94a3b8;font-size:13px">Nenhum envio encontrado.</div>';
  let html = '<div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;padding:10px 12px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;flex-wrap:wrap;position:sticky;top:0;z-index:5">'
    + '<label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:13px;color:#64748b;font-weight:600">'
    + '<input type="checkbox" id="hist-select-all" onchange="toggleAllHist(this)" style="width:16px;height:16px;cursor:pointer;accent-color:#1F3864"> Selecionar todas'
    + '</label>'
    + '<span id="hist-sel-count" style="font-size:12px;color:#94a3b8;font-weight:700"></span>'
    + '<div id="hist-actions" style="display:none;gap:6px;margin-left:auto;flex-wrap:wrap">'
    + '<button onclick="approveSelectedHist(this)" style="background:#16a34a;color:#fff;border:none;border-radius:8px;padding:6px 14px;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit">✓ Aprovar selecionadas</button>'
    + '<button onclick="rejectSelectedHist(this)" style="background:#fff;color:#dc2626;border:1.5px solid #fca5a5;border-radius:8px;padding:6px 14px;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit">✕ Reprovar selecionadas</button>'
    + '<button onclick="deleteSelectedHist(this)" style="background:#dc2626;color:#fff;border:none;border-radius:8px;padding:6px 14px;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit">🗑️ Excluir</button>'
    + '</div>'
    + '</div>';
  html += arr.map(function (s) {
    const cor = COR_FORM[s.classificacao.faixa];
    const label = s.status === 'aprovada' ? 'Aprovado' : s.status === 'reprovada' ? 'Rejeitado' : 'Pendente';
    const tg = s.status === 'aprovada' ? 'ok' : s.status === 'reprovada' ? 'no' : 'wt';
    const dt = s.enviadaEm ? new Date(s.enviadaEm).toLocaleDateString('pt-BR') : '';
    const anexo = s.tipo === 'anexo';
    function bt(sid: string, fn: string, cls: string, txt: string) { return '<button data-sid="' + esc(sid) + '" onclick="' + fn + '(this)" class="hx-b ' + cls + '">' + txt + '</button>'; }
    return '<div class="hist-item hx" data-sub-id="' + esc(s.id) + '" data-id="' + esc(s.id) + '">'
      + '<div class="hx-top">'
      + '<input type="checkbox" class="hist-cb" data-id="' + esc(s.id) + '" onchange="updateHistSel()" aria-label="Selecionar vistoria" style="width:18px;height:18px;cursor:pointer;flex-shrink:0;accent-color:#24354F">'
      + '<div class="hx-sc" style="color:' + cor + '">' + (typeof s.nota === 'number' ? Math.round(s.nota) + '%' : '📎') + '</div>'
      + '<div class="hx-nm"><b>' + esc(s.alojNome) + '</b><span>' + esc(s.obraNome) + '</span></div>'
      + '<div class="hx-c"><span>Responsável</span>' + esc(s.responsavel) + '</div>'
      + '<div class="hx-c"><span>Competência</span>' + esc(s.competenciaRotulo) + (s.semana ? ' · ' + s.semana + 'ª' : '') + (anexo ? ' · 📎' : '') + '</div>'
      + '<div class="hx-c"><span>Enviada em</span>' + dt + '</div>'
      + '<span class="hx-tag ' + tg + '">' + label + '</span>'
      + '</div>'
      + (s.motivoReprovacao ? '<div class="hx-mot"><strong>Motivo da reprovação:</strong> ' + esc(s.motivoReprovacao) + '</div>' : '')
      + '<div class="hx-act">'
      + (s.status !== 'aprovada' ? bt(s.id, 'approvePDFById', 'ap', '✓ Aprovar') : '')
      + (s.status !== 'reprovada' ? bt(s.id, 'rejectById', 'rj', '✕ Reprovar') : '')
      + bt(s.id, 'seePDFById', 'pd', '📄 PDF')
      + (!anexo ? bt(s.id, 'verFotosById', 'ft', '🖼️ Fotos') : '')
      + ((s.status === 'aprovada' || s.status === 'reprovada') && s.email ? bt(s.id, 'notificarColaboradorById', 'nt', '✉️ Notificar') : '')
      + bt(s.id, 'delSubById', 'dl', '🗑️')
      + '</div>'
      + '<div id="reject-form-' + esc(s.id) + '"></div>'
      + '</div>';
  }).join('');
  return html;
}

export function updateHistSel() {
  const cbs = document.querySelectorAll('.hist-cb');
  const checked = document.querySelectorAll('.hist-cb:checked');
  const countEl = document.getElementById('hist-sel-count');
  const acts = document.getElementById('hist-actions');
  const allCb = document.getElementById('hist-select-all') as HTMLInputElement;
  if (countEl) countEl.textContent = checked.length > 0 ? checked.length + ' selecionada(s)' : '';
  if (acts) acts.style.display = checked.length > 0 ? 'flex' : 'none';
  if (allCb) allCb.checked = checked.length === cbs.length && cbs.length > 0;
  cbs.forEach(function (cb: any) {
    const row = cb.closest('.hist-item');
    if (row) row.style.background = cb.checked ? '#eff6ff' : '';
  });
}
export function toggleAllHist(cb: any) {
  document.querySelectorAll('.hist-cb').forEach(function (c: any) { c.checked = cb.checked; });
  updateHistSel();
}

export function approvePDFById(btn: any) { doApprove(btn.getAttribute('data-sid')); }
export function delSubById(btn: any) { deleteSub(btn.getAttribute('data-sid')); }
export function seePDFById(btn: any) { seePDF(btn.getAttribute('data-sid')); }
export function rejectById(btn: any) { doReject(btn.getAttribute('data-sid')); }

export async function deleteSub(id: string) {
  if (semAprovar()) return;
  // decisão 7.8: confirmação antes de excluir
  if (!confirm('Excluir esta vistoria? Não tem como desfazer.')) return;
  try {
    await api('DELETE', '/api/vistorias/' + encodeURIComponent(id));
    toast('🗑️ Vistoria excluída', 'error');
  } catch (e: any) { if (silencioso401(e)) return; toast('⚠️ Não foi possível excluir: ' + e.message, 'error'); }
  renderAdmin(S.tab);
}

export function doReject(id: string, rowEl?: any) {
  if (semAprovar()) return;
  const existing = document.getElementById('reject-form-' + id);
  if (existing && existing.childElementCount) { existing.innerHTML = ''; return; }
  const row = rowEl || document.querySelector('[data-sub-id="' + CSS.escape(id) + '"]') || document.querySelector('[data-id="' + CSS.escape(id) + '"]');
  if (!row) { toast('Selecione a vistoria no histórico para reprovar', 'error'); return; }
  const holder = existing || row;
  const form = document.createElement('div');
  form.style.cssText = 'background:#fef2f2;border:1.5px solid #fca5a5;border-radius:10px;padding:12px;margin-top:8px';
  const lbl = document.createElement('div'); lbl.style.cssText = 'font-size:12px;font-weight:700;color:#b91c1c;margin-bottom:8px'; lbl.textContent = 'Motivo da reprovação (obrigatório):';
  const ta = document.createElement('textarea'); ta.id = 'reject-motivo-' + id; ta.rows = 2; ta.placeholder = 'Ex: Banheiros sujos, camas sem lençol...';
  ta.style.cssText = 'width:100%;border:1.5px solid #fca5a5;border-radius:8px;padding:8px 10px;font-size:13px;font-family:inherit;resize:none;margin-bottom:8px;color:#1e293b;outline:none;box-sizing:border-box';
  const btnRow = document.createElement('div'); btnRow.style.cssText = 'display:flex;gap:8px';
  const confirmBtn = document.createElement('button');
  confirmBtn.style.cssText = 'flex:1;background:#dc2626;color:#fff;border:none;border-radius:8px;padding:8px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit';
  confirmBtn.textContent = '✕ Confirmar reprovação';
  confirmBtn.onclick = function () { confirmReject(id, ta); };
  const cancelBtn = document.createElement('button');
  cancelBtn.style.cssText = 'background:#f1f5f9;color:#64748b;border:none;border-radius:8px;padding:8px 14px;font-size:13px;cursor:pointer;font-family:inherit';
  cancelBtn.textContent = 'Cancelar';
  cancelBtn.onclick = function () { form.remove(); };
  btnRow.appendChild(confirmBtn); btnRow.appendChild(cancelBtn);
  form.appendChild(lbl); form.appendChild(ta); form.appendChild(btnRow);
  holder.appendChild(form); ta.focus();
}

async function confirmReject(id: string, el: HTMLTextAreaElement) {
  const motivo = el ? el.value.trim() : '';
  if (!motivo) { el.style.borderColor = '#dc2626'; el.focus(); return; }
  try {
    await api('PATCH', '/api/vistorias/' + encodeURIComponent(id) + '/analise', { status: 'reprovada', motivo });
    toast('✕ Vistoria reprovada', 'error');
  } catch (e: any) { if (silencioso401(e)) return; toast('⚠️ ' + e.message, 'error'); }
  renderAdmin(S.tab);
}

// ── Notificar por e-mail ──
export function notificarColaboradorById(btn: any) { notificarColaborador(btn.getAttribute('data-sid')); }
async function notificarColaborador(id: string) {
  const s = vistoria(id);
  if (!s) { toast('Vistoria não encontrada', 'error'); return; }
  if (!can('notificar')) { toast('🔒 Seu acesso não permite enviar notificações', 'error'); return; }
  if (!s.email) { toast('Esta vistoria não tem e-mail do colaborador cadastrado', 'error'); return; }
  if (s.status !== 'aprovada' && s.status !== 'reprovada') { toast('Aprove ou reprove a vistoria antes de notificar', 'error'); return; }
  try {
    const r: any = await api('GET', '/api/vistorias/' + encodeURIComponent(id) + '/notificacao');
    window.location.href = r.mailto;
  } catch (e: any) { if (!silencioso401(e)) toast('⚠️ ' + e.message, 'error'); }
}

// ── PDF / anexo ──
function abrirAnexo(s: VistoriaDTO) {
  toast('📥 Carregando anexo...');
  baixarUrl('/api/anexos/' + encodeURIComponent(s.id), s.anexoNome || ('vistoria-' + s.id + '.pdf'));
}
export async function seePDF(id: string, dto?: VistoriaDTO) {
  const s = dto || vistoria(id);
  if (s && s.tipo === 'anexo') { abrirAnexo(s); return; }
  if (!s || s.qtdFotos > 0) toast('📥 Carregando fotos da vistoria...');
  try {
    const c = await api<VistoriaCompletaDTO>('GET', '/api/vistorias/' + encodeURIComponent(id));
    if (c.tipo === 'anexo') { abrirAnexo(c); return; }
    buildPDF(relatorioDaApi(c));
  } catch (e: any) {
    if (!silencioso401(e)) toast('Vistoria nao encontrada', 'error');
  }
}

// ── Galeria de fotos (visualização inline, além do PDF) ──
export function verFotosById(btn: any) { verFotos(btn.getAttribute('data-sid')); }
async function verFotos(id: string) {
  const s = vistoria(id);
  if (s && !s.qtdFotos) { toast('Esta vistoria não tem fotos', 'error'); return; }
  toast('📥 Carregando fotos...');
  try {
    const c = await api<VistoriaCompletaDTO>('GET', '/api/vistorias/' + encodeURIComponent(id));
    if (!c.fotos.length) { toast('Nenhuma foto encontrada para esta vistoria', 'error'); return; }
    const gerais: string[] = [], itens: Record<string, string[]> = {};
    c.fotos.slice().sort(function (a, b) { return a.ordem - b.ordem; }).forEach(function (f) {
      if (f.tipo === 'geral') gerais.push(f.url); else (itens[String(f.itemN)] = itens[String(f.itemN)] || []).push(f.url);
    });
    abrirGaleria(gerais, itens, c);
  } catch (e: any) {
    if (!silencioso401(e)) toast('Não consegui carregar as fotos: ' + e.message, 'error');
  }
}
function abrirGaleria(genPhotos: string[], itemPhotos: Record<string, string[]>, v: VistoriaCompletaDTO) {
  const fotos: { src: string; label: string }[] = [];
  (genPhotos || []).forEach(function (src, i) { fotos.push({ src: src, label: 'Foto geral ' + (i + 1) }); });
  Object.keys(itemPhotos || {}).sort(function (a, b) { return parseInt(a) - parseInt(b); }).forEach(function (n) {
    const it = v.checklist.find(function (x) { return String(x.n) === String(n); });
    const base = it ? ('Item ' + n + ': ' + it.descricao) : ('Item ' + n);
    const arr = itemPhotos[n] || [];
    arr.forEach(function (src, i) { fotos.push({ src: src, label: base + (arr.length > 1 ? ' (' + (i + 1) + ')' : '') }); });
  });
  if (!fotos.length) { toast('Nenhuma foto encontrada para esta vistoria', 'error'); return; }
  const old = document.getElementById('photo-gallery-overlay'); if (old) old.remove();
  const overlay = document.createElement('div'); overlay.id = 'photo-gallery-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(6,14,26,.94);z-index:9999;display:flex;flex-direction:column;overflow:hidden';
  const hdr = document.createElement('div'); hdr.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:14px 18px;flex-shrink:0;padding-top:max(14px,env(safe-area-inset-top))';
  const title = document.createElement('div'); title.style.cssText = 'color:#fff;font-weight:800;font-size:14px'; title.textContent = '🖼️ Fotos da vistoria (' + fotos.length + ')';
  const closeBtn = document.createElement('button'); closeBtn.textContent = '✕ Fechar'; closeBtn.style.cssText = 'background:rgba(255,255,255,.12);border:none;color:#fff;border-radius:8px;padding:8px 14px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit';
  closeBtn.onclick = function () { overlay.remove(); };
  hdr.appendChild(title); hdr.appendChild(closeBtn); overlay.appendChild(hdr);
  const grid = document.createElement('div'); grid.style.cssText = 'flex:1;overflow-y:auto;padding:0 18px 18px;display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:10px';
  fotos.forEach(function (f, idx) {
    const cell = document.createElement('div'); cell.className = 'gallery-thumb'; cell.style.cssText = 'cursor:pointer';
    cell.innerHTML = '<img src="' + f.src + '" style="width:100%;height:110px;object-fit:contain;background:#0f172a;border-radius:10px;border:1px solid rgba(255,255,255,.15);display:block">'
      + '<div style="font-size:10px;color:rgba(200,220,248,.7);margin-top:4px;line-height:1.3">' + esc(f.label) + '</div>';
    cell.onclick = function () { abrirLightbox(fotos, idx); };
    grid.appendChild(cell);
  });
  overlay.appendChild(grid);
  overlay.onclick = function (e) { if (e.target === overlay) overlay.remove(); };
  document.body.appendChild(overlay);
}
function abrirLightbox(fotos: { src: string; label: string }[], idx: number) {
  const old = document.getElementById('photo-lightbox'); if (old) old.remove();
  const box = document.createElement('div'); box.id = 'photo-lightbox';
  box.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.96);z-index:10000;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:20px;box-sizing:border-box';
  function render() {
    const f = fotos[idx] as { src: string; label: string };
    box.innerHTML = '';
    const imgWrap = document.createElement('div'); imgWrap.style.cssText = 'flex:1;min-height:0;display:flex;align-items:center;justify-content:center;max-width:100%;width:100%';
    const img = document.createElement('img'); img.src = f.src; img.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;border-radius:8px';
    imgWrap.appendChild(img); box.appendChild(imgWrap);
    const cap = document.createElement('div'); cap.style.cssText = 'color:#fff;font-size:13px;margin-top:10px;text-align:center;flex-shrink:0'; cap.textContent = f.label + ' (' + (idx + 1) + '/' + fotos.length + ')'; box.appendChild(cap);
    const navRow = document.createElement('div'); navRow.style.cssText = 'display:flex;gap:12px;margin-top:14px;flex-shrink:0';
    const prevB = document.createElement('button'); prevB.textContent = '‹ Anterior'; prevB.disabled = idx === 0;
    prevB.style.cssText = 'background:rgba(255,255,255,.12);border:none;color:#fff;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;opacity:' + (idx === 0 ? '.4' : '1');
    prevB.onclick = function () { if (idx > 0) { idx--; render(); } };
    const nextB = document.createElement('button'); nextB.textContent = 'Próxima ›'; nextB.disabled = idx === fotos.length - 1;
    nextB.style.cssText = 'background:rgba(255,255,255,.12);border:none;color:#fff;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;opacity:' + (idx === fotos.length - 1 ? '.4' : '1');
    nextB.onclick = function () { if (idx < fotos.length - 1) { idx++; render(); } };
    const closeB = document.createElement('button'); closeB.textContent = '✕ Fechar';
    closeB.style.cssText = 'background:rgba(220,38,38,.35);border:none;color:#fff;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit';
    closeB.onclick = function () { box.remove(); };
    navRow.appendChild(prevB); navRow.appendChild(nextB); navRow.appendChild(closeB); box.appendChild(navRow);
  }
  render();
  box.onclick = function (e) { if (e.target === box) box.remove(); };
  document.body.appendChild(box);
}
